import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'
import Markup from '../../../atoms/Markup'

function DDPMarkupList ({
  pipeline,
  variables,
  dataAccessor,
  itemAccessor,
  type,
  className,
  style,
  itemClassName,
  itemStyle,
  itemProps,
  ...rest
}) {
  const { data, isLoading, error } = usePipelineDataContextWithVariables(pipeline, variables)

  const itemSeries = useMemo(() => {
    const getSeries = () => {
      const series = get(data, dataAccessor)
      if ([null, undefined].includes(series)) return []
      if (Array.isArray(series)) {
        return series
      }

      return []
    }
    const getItem = item => {
      const value = get(item, itemAccessor)
      if (value !== null && typeof value === 'object') {
        return null
      }
      if (Array.isArray(value)) {
        return null
      }

      return value
    }

    return getSeries().map(getItem)
  }, [data, dataAccessor, itemAccessor])

  if (isLoading || error) {
    return null
  }

  return (
    <div className={className} style={style} {...rest}>
      {(itemSeries || []).map((item, index) => (
        <Markup key={`markup_${index}`} value={item} type={type} className={itemClassName} style={itemStyle} {...itemProps} />
      ))}
    </div>
  )
}

DDPMarkupList.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  variables: PropTypes.any,

  /** Path to the array or item to display */
  dataAccessor: PropTypes.string,

  /** Path within array to item to display */
  itemAccessor: PropTypes.string,

  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  itemClassName: PropTypes.string,
  itemStyle: PropTypes.object,
  itemProps: PropTypes.object
}

export default DDPMarkupList
